import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminDeleteTsd = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tsdId: string) => {
      const result = await apiClient.adminTsd.deleteTsd.mutation({
        params: {
          tsdId,
        },
        body: undefined,
      });

      if (result.status !== 200) {
        throw result.body;
      }

      return result.body;
    },
    onSuccess: () => {
      toast.success('TSD deleted!');
      queryClient.invalidateQueries({ queryKey: ['admin-temporary-storages'] });
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error deleting TSD!');
    },
  });
};
